import React, { useEffect, useState } from "react";
import PageTitle from "../../components/DefaultStyles/PageTitle";
import ManageServer from "../../components/pages/Manage/Version/ManageServer";
import ManageVersion from "../../components/pages/Manage/Version/ManageVersion";
import { useApi } from "../../hooks/useApi";
import {
  ChatSection,
  ChatSectionTitle,
} from "../../components/pages/Party/ChatInfo/ChatSearch/ChatSearchResult";
import { toast } from "react-toastify";
import Loader from "../../components/DefaultStyles/Loader";
import LineBtn from "../../components/Button/LineBtn";
import AlertModal from "../../components/Modal/AlertModal";
import ManageCerti from "../../components/pages/Manage/Version/ManageCerti";
import ManagePayPg from "../../components/pages/Manage/Version/ManagePayPg";
import Flex from "../../components/DefaultStyles/Flex";
import ManageMacro from "../../components/pages/Manage/Version/ManageMacro";
import SpaceBetween from "../../components/DefaultStyles/SpaceBetween";
import ManageBlock from "../../components/pages/Manage/Version/ManageBlock";
import ManageYoutubeDaily from "../../components/pages/Manage/Version/ManageDef";
import ManageDefData from "../../components/pages/Manage/Version/ManageDef";

export default function Status() {
  const [fetch, setFecth] = useState(false);
  const [waitingModal, setWaitingModal] = useState(false);

  const { response, loading, error, fetchData } = useApi({
    method: "get",
    url: `version`,
  });

  const { response: dbResponse, error: dbError } = useApi({
    method: "post",
    url: fetch ? `develop/updatedb` : undefined,
  });

  const { response: svcResponse, loading: svcLoading } = useApi({
    method: "get",
    url: "version/scversion",
  });

  const {
    response: blockResponse,
    loading: blockLoading,
    fetchData: fetchBlockData,
  } = useApi({
    method: "get",
    url: "version/block",
  });

  const {
    response: defResponse,
    loading: defLoading,
    fetchData: fetchDefData,
  } = useApi({
    method: "get",
    url: "version/systemdef",
  });

  useEffect(() => {
    if (dbResponse?.status === 201) {
      setFecth(false);
      toast.success("백업 DB가 업데이트 되었습니다.");
    }
  }, [dbResponse]);

  const refetch = () => {
    fetchData({
      method: "get",
      url: `version`,
    });

    fetchBlockData({
      method: "get",
      url: `version/block`,
    });

    fetchDefData({
      method: "get",
      url: `version/systemdef`,
    });
  };

  useEffect(() => {
    if (error || dbError) {
      setFecth(false);

      toast.error(
        dbError?.data ??
          error?.data ??
          "버전 및 서버 정보를 가져오는 데에 실패하였습니다.",
      );
    }
  }, [error, dbError]);

  console.log(svcResponse);

  return (
    <>
      <SpaceBetween>
        <PageTitle title="상태 관리" />

        <>
          {svcResponse?.status === 200 ? `v${svcResponse?.data?.version}` : ""}
        </>
      </SpaceBetween>

      <Flex gapSize={10}>
        <LineBtn
          btnText="백업 DB 업데이트"
          btnClickEvent={() => {
            setFecth(true);
            setTimeout(() => {
              setWaitingModal(true);
            }, 1500);
          }}
        />
      </Flex>

      <ChatSection>
        <ChatSectionTitle>개인 연간파티 일일 생성 제한 갯수</ChatSectionTitle>

        <ManageDefData
          defData={defResponse?.data}
          refetch={() => refetch()}
        />
      </ChatSection>

      <ChatSection>
        <ChatSectionTitle>인출 제한 관리</ChatSectionTitle>

        <ManageBlock
          blockData={blockResponse?.data}
          refetch={() => refetch()}
        />
      </ChatSection>

      {/* 버전 관리 */}
      <ChatSection>
        <ChatSectionTitle>버전 관리</ChatSectionTitle>

        <ManageVersion
          versionData={response?.data?.version}
          refetch={() => refetch()}
        />
      </ChatSection>
      {/* 서버 관리 */}
      <ChatSection>
        <ChatSectionTitle>서버 관리</ChatSectionTitle>

        <ManageServer
          serverData={response?.data?.server}
          refetch={() => refetch()}
        />
      </ChatSection>
      {/* 본인 인증 관리 */}
      <ChatSection>
        <ChatSectionTitle>본인 인증 관리</ChatSectionTitle>

        <ManageCerti
          certiData={response?.data?.certi}
          refetch={() => refetch()}
        />
      </ChatSection>

      {/* 결제 PG사 우선 순위 관리 */}
      <ChatSection>
        <ChatSectionTitle>결제 PG사 관리</ChatSectionTitle>

        <ManagePayPg />
      </ChatSection>

      {loading && <Loader />}
      {fetch && waitingModal && (
        <AlertModal
          title={`10분 후 처리 됩니다.`}
          btnColor="mint"
          customCancelBtn={<></>}
          confirmEvent={() => {
            setWaitingModal(false);
            setFecth(false);
          }}
        />
      )}
    </>
  );
}
